import React, { useContext } from "react";
import { Fragment } from "react";
import { Link, Outlet } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import MarketNavbar from "./MarketNav/MarketNavbar";

import SimpleSlider from "./Banner/BannerSlider";

import useRecommendedLimit from "./libs/fetchLimitRecommended.js";

import useTrendingLimit from "./libs/fetchLimitTrending";

import useTopSellingLimit from "./libs/fetchLimitTopselling";

import useTodayDealLimit from "./libs/fetchLimitTodayDeal";

import useFetchProductCategory from "../../libs/getProductCategories.js";

import "./Market.css";

import { getCategoryPath } from "./libs/categoryRoutes";

import MarketProductSection from "./components/MarketProductSection";

import { MARKET_HOME_SECTIONS } from "./libs/marketSectionMeta";

import MarketplacePage from "./components/MarketplacePage";

import CategorySidebarSkeleton from "./components/CategorySidebarSkeleton";

import { getCategoryIcon } from "./libs/categoryIcons";

import { CartContext } from "../../Context/CartContext";

import useQuickAddToCart from "./libs/useQuickAddToCart";

import QuickAddSizeModal from "./components/QuickAddSizeModal";

import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";



const MARKET_SECTION_LIMIT = 8;



const Market = () => {

  const { addItemToCart } = useContext(CartContext);

  const { quickAdd, pending, confirmSize, cancelSize } = useQuickAddToCart(addItemToCart);

  const handleAddToCart = (product) => quickAdd(product);



  const { data: trendingLimit, isLoading: trendingLoading, isError: trendingError } = useTrendingLimit();

  const { data: todayDealLimit, isLoading: todayLoading, isError: todayError } = useTodayDealLimit();

  const { data: topsellingLimit, isLoading: topLoading, isError: topError } = useTopSellingLimit();

  const { data: recommendedLimit, isLoading: recommendedLoading, isError: recommendedError } = useRecommendedLimit();

  const { data, isLoading: productCategoryLoading, isError: productCategoryError } = useFetchProductCategory();



  const sections = [
    {
      ...MARKET_HOME_SECTIONS.recommended,
      isLoading: recommendedLoading,
      isError: recommendedError,
      products: recommendedLimit?.products || [],
    },
    {
      ...MARKET_HOME_SECTIONS.trending,
      isLoading: trendingLoading,
      isError: trendingError,
      products: trendingLimit?.trendingProducts || [],
    },
    {
      ...MARKET_HOME_SECTIONS.todayDeals,
      isLoading: todayLoading,
      isError: todayError,
      products: todayDealLimit?.todaysDealProducts || [],
    },
    {
      ...MARKET_HOME_SECTIONS.topSelling,
      isLoading: topLoading,
      isError: topError,
      products: topsellingLimit?.hotDealProducts || [],
    },
  ];



  return (

    <Fragment>

      <MarketNavbar />

      <MarketplacePage className="marketplace-page--flush-top">

        <div className="market-mother-cards">

          <div className={`market-con-1${productCategoryLoading ? " market-con-1--loading" : ""}`}>

            {productCategoryLoading ? (

              <CategorySidebarSkeleton />

            ) : productCategoryError ? (

              <div className="market-category-error">Error loading categories</div>

            ) : data?.categories?.length > 0 ? (

              data.categories.map((category) => (

                <Link to={getCategoryPath(category.categoryName)} key={category._id}>

                  {getCategoryIcon(category.categoryName)}

                  {category.categoryName}

                </Link>

              ))

            ) : (

              <p style={{ fontFamily: "Montserrat" }}>No categories available</p>

            )}

          </div>

          <div className="market-con-2">

            <SimpleSlider />

          </div>

          <div className="market-con-3">

            <div className="card-1">

              <h3>Where selling meets simplicity</h3>

              <p>

                Connect with customers, showcase your products, and turn your

                passion into profit seamlessly.

              </p>

              <Link to="/market/sell">Become a merchant</Link>

            </div>

            <div className="card-2">

              <div className="overlay">

                <Link to="/market/deals/trending">Shop Now</Link>

              </div>

            </div>

            <div className="card-3">

              <div className="overlay">

                <Link to="/market/deals/today">Shop Now</Link>

              </div>

            </div>

            <div className="card-4">

              <div className="overlay">

                <Link to="/market/deals/top-selling">Shop Now</Link>

              </div>

            </div>

          </div>

        </div>

        <div className="market-mobile-categories" aria-label="Browse categories">
          {productCategoryLoading ? (
            <>
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} height={36} width={100} borderRadius={999} />
              ))}
            </>
          ) : (
            data?.categories?.map((category) => (
              <Link to={getCategoryPath(category.categoryName)} key={category._id} className="market-mobile-categories__chip">
                {category.categoryName}
              </Link>
            ))
          )}
        </div>

        {sections.map((section) => (

          <MarketProductSection

            key={section.title}

            title={section.title}

            Icon={section.Icon}

            viewAllLink={section.link}

            isLoading={section.isLoading}

            isError={section.isError}

            products={section.products}

            errorMessage={section.errorMessage}

            emptyMessage={section.emptyMessage}

            onAddToCart={handleAddToCart}

            limit={MARKET_SECTION_LIMIT}

          />

        ))}



        <Outlet />

      </MarketplacePage>

      <QuickAddSizeModal pending={pending} onConfirm={confirmSize} onCancel={cancelSize} />
      <ToastContainer position="top-right" className="toast" />

    </Fragment>

  );

};



export default Market;


